import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

export interface ContactInformationForm {
    customerEmail: string;
    tasEmail: string;
    salesRepEmail: string;
    pmInstallationEmail: string;
}

export interface AdditionalContactFormGroup {
    title: FormControl<string | null>;
    email: FormControl<string | null>;
}

export interface ContactInformationFormGroup {
    customerEmail: FormControl<string | null>;
    tasEmail: FormControl<string | null>;
    salesRepEmail: FormControl<string | null>;
    pmInstallationEmail: FormControl<string | null>;
    additionalContacts: FormArray<FormGroup<AdditionalContactFormGroup>>;
}

export const createAdditionalContactFormGroup = (): FormGroup<AdditionalContactFormGroup> => {
    return new FormGroup<AdditionalContactFormGroup>({
        title: new FormControl<string | null>(null),
        email: new FormControl<string | null>(null, Validators.email)
    });
};

export const createContactInformationFormGroup = (): FormGroup<ContactInformationFormGroup> => {
    return new FormGroup<ContactInformationFormGroup>({
        customerEmail: new FormControl<string | null>(null, [Validators.required, Validators.email]),
        tasEmail: new FormControl<string | null>(null, [Validators.required, Validators.email]),
        salesRepEmail: new FormControl<string | null>(null, Validators.email),
        pmInstallationEmail: new FormControl<string | null>(null, Validators.email),
        additionalContacts: new FormArray<FormGroup<AdditionalContactFormGroup>>([createAdditionalContactFormGroup()])
    });
};
